// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__Rcyuk","insightsList":"newBusinessInsightsMenu_insightsList__L14Vw","active":"newBusinessInsightsMenu_active__2Y8dC"};